(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[667],{

/***/ "CWIx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Minus", function() { return Minus; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;

var Minus = function Minus(_ref) {
  var xRef = _ref.xRef,
      props = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["xRef"]);

  return __jsx("svg", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
    viewBox: "0 0 30 30"
  }, props, {
    ref: xRef
  }), __jsx("path", {
    d: "M3.49493393,13.8030277 C3.81550558,13.4841703 4.23893446,13.3075988 4.68807763,13.3075988 L25.3057895,13.3058845 C26.2383616,13.3058845 26.9977907,14.0653136 26.999505,14.9961714 C26.9977907,15.4521718 26.8229334,15.8790292 26.5040761,16.1978866 C26.1852187,16.5167439 25.7600755,16.6916012 25.3057895,16.6933155 L4.6932205,16.6933155 C4.23893446,16.6933155 3.81550558,16.5167439 3.49493393,16.1961723 C3.17607655,15.8773149 2.999505,15.4521718 2.999505,14.9978857 C2.999505,14.5487425 3.17607655,14.1235994 3.49493393,13.8030277 Z"
  }));
};

/***/ })

}]);